import type { ReactNode } from 'react';

import { close as IconClose } from '@/components/icons/close';
import { cn } from '@/utils/cn';

import { Button } from '../button';

interface BannerProps {
  isOpen: boolean;
  isDisableCloseIcon?: boolean;
  isCookiePrivacy?: boolean;
  icon?: ReactNode;
  children: ReactNode;
  close?: VoidFunction;
}

const Banner: React.FC<BannerProps> = ({ isOpen, isDisableCloseIcon, isCookiePrivacy, icon, children, close }: BannerProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={cn(
        'absolute bg-surface-secondary p-6 flex justify-between z-50',
        isCookiePrivacy
          ? '-bottom-4 lg:bottom-0 -right-4 lg:right-auto -left-4 lg:left-auto max-w-lg lg:border lg:border-border-secondary lg:rounded-lg'
          : 'lg:top-6 lg:left-6 lg:right-6',
      )}
    >
      <div className="flex gap-6">
        {icon && <div className="hidden lg:block">{icon}</div>}
        <div>{children}</div>
      </div>
      {!isDisableCloseIcon && close && (
        <div>
          <Button onClick={close} variant="tertiary" className="bg-transparent -mt-3 -mr-3">
            <IconClose className="text-text-secondary" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default Banner;
